import { Component, OnInit, ElementRef, Input } from '@angular/core';
import {PdfService} from "../services/pdf.service";
import { ActivatedRoute } from '@angular/router';
import { Assignment } from '../models/Assignment';

@Component({
  selector: 'dac-pdf-generate-btn',
  templateUrl: './pdf-generate-btn.component.html'
})
export class PdfGenerateBtnComponent implements OnInit {

  @Input() file:string;
  @Input() assignment:Assignment;
  public printing:boolean;

  constructor(private element:ElementRef, private pdfService:PdfService
  ,private activeRoute:ActivatedRoute) { 
    this.printing = false;
  }

  ngOnInit() {
  }


  public print() {
    let name = this.file || "File";
    let element = this.element.nativeElement as HTMLElement;
    let html = element.ownerDocument.documentElement.innerHTML;
    this.printing = true;
    if (!(window && window.location)) {
      console.error("window or window.location is missing");
      return;
    }
    let url = window.location.href;
    this.pdfService.generate(url, this.assignment).then(() => {
      this.printing = false;
      console.log("document printed");
    })
    .catch((error) => {
      alert("There was an error in generating your pdf.  Please check your internet connection and try again");
      this.printing = false;
      console.error(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pdf-generate-btn/pdf-generate-btn.component.ts